<template>
  <piepkaart
    :minLoadDataZoom="14"
    :legend="legend"
    @popupopen="onPopup"
    name="Bouwjaar"
  >
    <template v-slot="{ bounds, minLoadDataZoom }">
      <piepkaart-wfs-layer
        :bounds="bounds"
        :minLoadDataZoom="minLoadDataZoom"
        wfs-url="https://service.pdok.nl/lv/bag/wfs/v2_0"
        type-name="bag:pand"
        output-format="application/json; subtype=geojson"
        srs-name="EPSG:4326"
        version="2.0.0"
        sortBy="bouwjaar"
        :onEachFeature="onEachFeature"
        :styleOptions="styleOptions"
        :reverseBbox="true"
        :use-proxy="false"
        :minRefetchDistance="10"
      ></piepkaart-wfs-layer>
    </template>
  </piepkaart>
</template>
<script>
import Piepkaart from "@/components/Piepkaart.vue";
import PiepkaartWfsLayer from "@/components/PiepkaartWfsLayer.vue";
export default {
  name: "Bouwjaar-Gebouwen",
  components: {
    Piepkaart,
    PiepkaartWfsLayer,
  },
  data() {
    return {
      legend: [
        { color: "#9b2c2c", label: "0 - 1500" },
        { color: "#e53e3e", label: "1500 - 1600" },
        { color: "#dd6b20", label: "1600 - 1700" },
        { color: "#f6ad55", label: "1700 - 1800" },
        { color: "#f6e05e", label: "1800 - 1900" },
        { color: "#68d391", label: "1900 - 2000" },
        { color: "#c6f6d5", label: "2000 - 2100" },
      ],
    };
  },
  methods: {
    styleOptions() {
      return {
        weight: 1,
        color: "#000",
        opacity: 1,
        fillColor: "#ccc",
        fillOpacity: 1,
      };
    },
    onEachFeature(feature, layer) {
      if (feature.properties) {
        if (feature.properties.bouwjaar < 1500) {
          layer.setStyle({
            fillColor: "#9b2c2c",
          });
        } else if (feature.properties.bouwjaar < 1600) {
          layer.setStyle({
            fillColor: "#e53e3e",
          });
        } else if (feature.properties.bouwjaar < 1700) {
          layer.setStyle({
            fillColor: "#dd6b20",
          });
        } else if (feature.properties.bouwjaar < 1800) {
          layer.setStyle({
            fillColor: "#f6ad55",
          });
        } else if (feature.properties.bouwjaar < 1900) {
          layer.setStyle({
            fillColor: "#f6e05e",
          });
        } else if (feature.properties.bouwjaar < 2000) {
          layer.setStyle({
            fillColor: "#68d391",
          });
        } else if (feature.properties.bouwjaar < 2100) {
          layer.setStyle({
            fillColor: "#c6f6d5",
          });
        }

        layer.bindPopup(
          `
            <div>Bouwjaar: <span style="font-weight: 700">${feature.properties.bouwjaar}</span></div>
            <div>Gebruiksdoel: ${feature.properties.gebruiksdoel}</div>
            <div>Status: ${feature.properties.status}</div>
            `,
          {
            closeButton: false,
            autoPan: false,
          }
        );
      }
    },
    onPopup(popup) {
      if (!popup.feature) return;
      const latlng = popup._popup._latlng;
      const location = `${parseFloat(latlng.lat.toFixed(6))},${parseFloat(
        latlng.lng.toFixed(6)
      )}`;
      const { bouwjaar } = popup.feature.properties;
      window.gtag("event", "gebouwen", {
        location: location,
        bouwjaar: bouwjaar,
      });
    },
  },
};
</script>